<template>
  <div v-if="displayOptions.length > 0" class="ds-display-option-docs">
    <dl class="dl mts">
      <template v-for="(dos, idx) in displayOptions" :key="'dt-' + idx">
        <dt class="dt">{{ dos.option }}</dt>
        <dd class="dd" v-html="dos.desc"></dd>
      </template>
    </dl>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import { DisplayOptionDoc, GlueDocs } from "./glue-documentation-types";

@Component({ name: "display-option-docs" })
export default class GlueDocDisplayOptions extends Vue {
  @Prop(String)
  public readonly componentName!: string;

  get displayOptions(): DisplayOptionDoc[] {
    const doc: GlueDocs = window[this.componentName + "-docs"];
    if (doc != null) {
      if (doc.displayOptions) {
        return doc.displayOptions;
      }
    }
    return [];
  }
}
</script>
